



















import { Component, Mixins, Prop, Watch, Emit } from 'vue-property-decorator';
import { getDateFormattedAsMoment, hasElements } from '../utils';
import Axios from 'axios';
import { NotificationStoreHelper, RootStoreHelper } from '../mixins';
import { Destroyed, Mounted } from '../decorators';
import moment from 'moment';
import { dateTypes } from '../models';

@Component({
    components: {}
})
export default class ImagesStrip extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    @Prop({ default: [] }) images: Array<object>;
    @Prop({ default: 'src' }) imageSrc: string;
    @Prop({ default: 0 }) currentIndex: number;
    hovered: boolean = false;
    selectedId: number = -1;
    timer: any = null;

    @Emit()
    mouseOverImage(currentElement) {
        return currentElement;
    }

    mouseOverEvent(currentElement, index) {
        this.selectedId = index;
        let self = this;
        this.timer = setTimeout(() => {
            if (self.selectedId === index) self.hovered = true;
            self.mouseOverImage(currentElement);
        }, 1000);
    }

    resetMouseOver() {
        clearTimeout(this.timer);
        this.timer = 0;
        this.selectedId = -1;
    }

    scrollToRight() {
        let content: any = document.querySelector('.images-strip');
        content.scrollLeft += 40;
    }

    scrollToLeft() {
        let content: any = document.querySelector('.images-strip');
        content.scrollLeft -= 40;
    }

    getParsedDate(date) {
        return getDateFormattedAsMoment(date, dateTypes.dateYearFormatBars, dateTypes.dateYearFormatReverse)
    }

    mounted(){
        this.clickImage(this.currentIndex, this.images[this.currentIndex]);
    }

    @Emit()
    clickImage(index, currentElement) {}
}
